import { useQuery } from "@tanstack/react-query";
import { apiLogger } from "../../Utils/logger";
import { leaderboardApi } from "../../routes/Tribe/leaderboard";

// leaderboard query
export const useLeaderboardDetail = (enabled = true) => {
  return useQuery({
    queryKey: ["leaderboard", "leaderboardDetail"],
    queryFn: async () => {
      try {
        apiLogger.apiRequest("GET", "/v3/leaderboard");
        const response = await leaderboardApi.getLeadership();
        apiLogger.apiResponse("GET", "/v3/leaderboard", response, 200);

        // Extract the data from response.data.data (following the old pattern)
        return response?.data || response;
      } catch (error) {
        apiLogger.apiError(
          "GET",
          "/v3/leaderboard",
          error,
          error.response?.status,
        );
        throw error;
      }
    },
    enabled,
    retry: 1,
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
